import { HeadFC, PageProps } from "gatsby";
import React, { FC, useEffect } from "react";

import { BiesseLogo } from "../components/biesse-logo";
import { Clickable } from "../components/buttons/button/clickable";
import { Container } from "../components/container";
import { Icon } from "../components/icon";
import { useTrackPageview } from "../hooks/use-track-pageview";
import "../styles/global.css";
import { ContentGroup } from "../types/analytics";

export interface NotFoundPageProps extends PageProps {}

const NotFoundPage: FC<NotFoundPageProps> = () => {
  const trackPageview = useTrackPageview();
  useEffect(() => {
    trackPageview({
      breadcrumbs: null,
      content_group: ContentGroup.NotFound,
      locale: null,
    });
  }, [trackPageview]);

  return (
    <div>
      <Container pagePaddingX containerFrom="md">
        <div className="flex flex-col items-center justify-center h-screen w-full text-center">
          <BiesseLogo className="text-primary" />
          <h1 className="text-9xl md:text-[180px] leading-none text-primary font-bold mt-10 md:mt-20">
            404
          </h1>
          <h3 className="text-3xl md:text-5xl leading-tight text-primary font-bold">
            Page not found
          </h3>
          <p className="text-lg md:text-xl text-dark mt-6 md:mt-12">
            {"Sorry, the page you're looking for doesn't exist."}
          </p>
          <a href="/" className="mt-6 md:mt-12">
            <Clickable variant="primary">
              <Icon icon="arrow-left" />
              <span className="ml-4">Back home</span>
            </Clickable>
          </a>
        </div>
      </Container>
    </div>
  );
};

export default NotFoundPage;

export const Head: HeadFC = () => <title>Not found</title>;
